<template>
  <div>
    <div class="control-section accordion-icons">
      <h3>Category</h3>
      <ejs-button type="button" cssClass="e-info" v-on:click.native="handleAddCategoryClick">
        <font-awesome-icon :icon="['fas', 'plus']" style="display: inline" />
        Add Category
      </ejs-button>
      <br />
      <br />
      <ejs-grid
        :dataSource="categories"
        ref="refSCCActiveUserList"
        enablePersistence="false"
        :selection-settings="selectionOptions"
        :commandClick="commandClick"
        :allowSorting="true"
        :allowPaging="true"
        :pageSettings="gridPageSettings"
        :actionComplete="onGridLoadComplete"
      >
        <e-columns>
          <e-column
            field="messageId"
            headerText="messageId"
            textAlign="Right"
            :isPrimaryKey="true"
            width="0"
          ></e-column>
          <e-column
            field="withDocuments"
            headerText="withDocuments"
            textAlign="Right"
            :visible="false"
            width="0"
          ></e-column>
          <e-column field="message" headerText="Group Title" width="120"></e-column>
          <e-column field="orderId" headerText="Order" textAlign="Right" width="120"></e-column>
          <e-column headerText="Commands" width="120" :commands="commands"></e-column>
        </e-columns>
      </ejs-grid>
      <forms-category-modal
        ref="formsCategoryModal"
        :category="selectedCategory"
        :showModal="showModal"
      />
      <div ref="spinnerEle" id="spinner"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import {
  GridPlugin, Page, Toolbar, Edit, CommandColumn,
} from "@syncfusion/ej2-vue-grids";
import {
  DialogPlugin, createSpinner, showSpinner, setSpinner,
} from "@syncfusion/ej2-vue-popups";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { isNullOrUndefined } from "@syncfusion/ej2-base";
import { DialogUtility } from "@syncfusion/ej2-popups";

import { FETCH_FORMS_CATEGORY, SET_SELECTED_FORMS_CATEGORY, DELETE_FORMS_CATEGORY } from "../store";
import FormsCategoryModal from "../components/forms-category-modal.vue";

Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);
Vue.use(GridPlugin);

let DialogObj;

export default {
  name: "FormsManage",
  components: { FormsCategoryModal },
  data() {
    return {
      showModal: false,
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      gridPageSettings: { pageSize: 10 },
      editSettings: { allowEditing: true, allowDeleting: true },
      commands: [
        {
          type: "GoTo",
          buttonOption: { cssClass: "e-flat", iconCss: "e-open-link e-icons" },
        },
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
        {
          type: "Delete",
          buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" },
        },
      ],
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn],
  },
  async created() {
    await this.initialize();
  },
  mounted() {
    createSpinner({ target: this.$refs.spinnerEle });
    showSpinner(this.$refs.spinnerEle);
  },
  computed: {
    ...mapGetters({
      category: "category",
      selectedCategory: "selectedCategory",
    }),
    categories() {
      return this.$store.getters.category;
    },
    dialogOpen() {},
  },
  methods: {
    onGridLoadComplete() {
      this.$refs.spinnerEle.style.display = "none";
    },
    handleAddCategoryClick() {
      this.$store.dispatch(SET_SELECTED_FORMS_CATEGORY, {
        message: null,
        orderId: 0,
      });

      this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[0].setContent("Add");

      this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[1].resetContent();
      this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[1].setContent(
        "Add",
        null,
      );
      this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.show();
    },
    btnClick() {
      this.$refs.templateDialog.show();
    },
    commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        this.$store.dispatch(SET_SELECTED_FORMS_CATEGORY, { ...args.rowData });

        this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[1].resetContent();
        this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[0].setContent("Edit");
        this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.$children[1].setContent("Edit", {
          ...args.rowData,
        });
        this.$refs.formsCategoryModal.$refs.AddEditCategoryDialog.show();
      } else if (args.commandColumn.type === "Delete") {
        if (args.rowData.withDocument) {
          this.$parent.notificationToasts.push({
            title: "Error!",
            content: "Documents are linked with this category.",
            cssClass: "e-toast-danger",
            timeOut: 5000,
          });
          this.$parent.$refs.notifierRef.show();
        } else {
          this.deleteCategory(args.rowData.messageId);
        }
      } else if (args.commandColumn.type === "GoTo") {
        const route = `/forms/category/${args.rowData.message}`;
        this.$router.push(route);
      }
    },
    setAddEditCategoryValues(data) {},
    deleteCategory(id) {
      DialogObj = DialogUtility.confirm({
        title: "Delete Category",
        content: "Are you sure you want to delete this record?",
        position: { X: "center", Y: "top" },
        okButton: {
          text: "Yes",
          click: async () => {
            await this.$store.dispatch(DELETE_FORMS_CATEGORY, { id });
            this.hideDeleteDialog();
          },
        },
        cancelButton: { text: "Cancel", click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" },
      });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    async initialize() {
      await this.$store.dispatch(FETCH_FORMS_CATEGORY);
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-popups/styles/material.css";
</style>
